export enum AstradeShop {
  PARKLON= 'parklon',
  IFAM = 'ifam',
  GUBKA = 'gubka'
}
